import React, { memo } from "react";
import AwesomeSlider from "react-awesome-slider";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import { Container } from "src/components/ct-design";
import { loginBannerImages } from "constants/home";
import CoreStyles from "react-awesome-slider/src/core/styles.scss";
import Image from "next/image";
import "./style.scss";
const BannerSlider = () => {
  const AutoplaySlider = withAutoplay(AwesomeSlider);

  return (
    <Container className="loginBanner">
      <AutoplaySlider
        cssModule={CoreStyles}
        play
        interval={2000}
        transitionDelay={0}
        organicArrows={false}
        cancelOnInteraction={false}
      >
        {loginBannerImages?.map((item, value) => (
          <div key={value} className="flex">
            <div className="flex flex-column">
              <div
                className="flex flex-center centered w-100vw m-0 banner-slider-image"
                style={{ backgroundColor: "#FFEEE8" }}
              >
                <Image
                  width="350"
                  height="288"
                  src={item?.url}
                  alt="Login Banner"
                />
              </div>
            </div>
          </div>
        ))}
      </AutoplaySlider>
    </Container>
  );
};
export default memo(BannerSlider);
